import { HyperLinkBuilder } from "../../../commonComponents/inline/hyperLink";
import { getNewlinkTargetProperties } from "../../../widgetsUtils";
import { PremiumPaywallState } from "./premiumPaywallDesktop";
import { getPaywallSettingsFromLocalStorage } from "../../../../global/paywall/authOperations"
import { CustomerAccessData, SiteLinks, SubscriptionPlan, PaywallPlans, ProductsUniqueIds } from "../../../../global/paywall/paywallInterfaces"
import { LinkTargetProperties } from "../../../../global/components/linkSettings/interfaces";
import { LegalLink } from "../../calcalist/calcalistPaywallForms/mobile/premiumCalcalistPaywallMobile"
import { getUserLabel } from "../../../../global/paywall/paywallUtils";


interface PaywallCheckoutPlansProps {
    handleSelectPlan?: (selectedPlan: string) => void
    setMode?: (state: PremiumPaywallState) => void
    insideCheckoutFlow?: boolean;
    nextStep?: (plan?) => void;
    setIsRedirecting?: (isRedirect: boolean) => void;
    handleChoosePlan?: () => void;
    legalLinks?: {
        terms?: LegalLink;
        privacy?: LegalLink;
    }
    proceedToEmailStep?: () => void;
    selectedUrl?: string;
    scrollToForm?: any;
}

export const defaultPlansObj = {
    "MONTHLY": {
        title: "חודשית",
        price: 29.90,
        frequency: "בתשלום חודשי מתחדש",
        buttonText: "להצטרפות",
        className: "monthly-plan",
        promotionText: "חודש ראשון ב-₪5.90",
        productUniqueId: ProductsUniqueIds.MONTHLY_PASS

    },
    "YEARLY": {
        title: "שנתית",
        price: 299.90,
        frequency: "בתשלום שנתי מתחדש",
        buttonText: "להצטרפות",
        className: "yearly-plan",
        promotionText: "",
        productUniqueId: ProductsUniqueIds.YEARLY_PASS
    }
}


declare const window: Window & {
    PAYWALL_PLANS: PaywallPlans
    PAYWALL_SITE_LINKS: SiteLinks;
}

const PremiumPaywallCheckoutPlans = (props: PaywallCheckoutPlansProps) => {
    const { handleSelectPlan, setMode, insideCheckoutFlow: insideCheckout, nextStep, proceedToEmailStep, scrollToForm } = props;
    const insideCheckoutFlowClass = insideCheckout ? 'checkout-flow' : '';
    const userData: CustomerAccessData = typeof window !== "undefined" && getPaywallSettingsFromLocalStorage();
    const titleDisplay = userData && userData.displayName ? `שלום ${getUserLabel(userData.displayName)}` : 'יש ידיעות שאסור לפספס!'
    const targetLink: LinkTargetProperties = { ...getNewlinkTargetProperties(), linkOpenType: "new" }
    const plansObj: PaywallPlans =
        typeof window !== 'undefined' && window.PAYWALL_PLANS
            ? window.PAYWALL_PLANS
            : defaultPlansObj;


    const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
    const termsUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.terms : '';
    const privacyUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.privacy : '';

const loginEvent =(mode)=>{
    setMode({ mode: mode })    
    const loginButtonEvent = new CustomEvent("loginButtonEvent",   { detail: {  mode: mode } })
    document.dispatchEvent(loginButtonEvent);
}
const handleNewspaperRegister = () => {
    setMode({ mode: 'signIn', isNewspaper: true })
    const newspaperRegisterEvent = new CustomEvent("handleNewspaperRegister")
    document.dispatchEvent(newspaperRegisterEvent);
}
    const handleSubscribeButton = (plan) => {
        if (insideCheckout && nextStep) {
            nextStep(plan);
            return;
        }
        const url = handleSelectPlan(plan);
        if (userData) {
            location.href = url as any;
        } else {
            proceedToEmailStep();
            scrollToForm();
        }
        const subscribeButtonEvent = new CustomEvent("onSubscribeButton",  { detail: { label: plan } })
        document.dispatchEvent(subscribeButtonEvent);
    };


    const subtitle = insideCheckout || userData ? (
        <div className="subtitle">
            כתבות <span className="bold">ידיעות+</span> והמהדורה הדיגיטלית
            של <span className="yedioth-label"></span> זמינות למנויים בלבד. להצטרפות במחיר משתלם
        </div>
    ) : (
        <div className="subtitle">
            מצטרפים ל<span className="bold">ידיעות+ </span>ונהנים מגישה <br />
            לכתבות הכי מעניינות <br />
            ולמהדורה הדיגיטלית של <span className="yedioth-label"></span>
        </div>
    );


    return (
        <div className={`PremiumPaywallCheckoutPlans ${insideCheckoutFlowClass}`}>
            <div className="title">{titleDisplay}</div>
            {subtitle}
            <div className="plans-container">
                {
                    Object.keys(plansObj).map((key, i) => {
                        const plan: SubscriptionPlan = plansObj[key]
                        return (
                            <button key={key} onClick={() => handleSubscribeButton(key)} className={`plan-box plan-button ${plan.className}`}>
                                <div className="plan-title">חבילה  {plan.title} </div>
                                <div className="plan-price">{plan.price.toFixed(2)}</div>
                                <div className="plan-price-frequency">{plan.frequency}</div>
                                <div className="plan-promo-text">{plan.promotionText}</div>
                                <div className="plan-button">{plan.buttonText}</div>
                            </button>
                        )
                    })
                }
            </div>
            <div className="cancel-text">
                ניתן לבטל את המינוי בכל עת לפי <HyperLinkBuilder linkTarget={targetLink} href={termsUrl}>תנאי השימוש</HyperLinkBuilder>; ולרוכשים <br /> ב-google play/apple store לפי מדיניותן
            </div>

            {userData || insideCheckout ? null :
                <>
                    <div className="login">
                        <div>כבר מנויים? <button type="button" onClick={() =>loginEvent('signIn')}>כניסה</button></div>
                    </div>
                    <div className="newspaper-users" >
                        <div><span>מנויים לעיתון</span> <span className="yedioth-label"></span></div>
                        <div onClick={() => handleNewspaperRegister()} className="newspaper-register-text">צרו חשבון ל-<div className="yedioth-plus-label"></div>ללא עלות</div>
                    </div>
                </>
            }
            
            <div className="newspaper-print">
                <div className="line">
                    <span>שלבו מינוי</span>
                    <span className="yedioth-plus-label"></span>
                
                    <span className="newspaper-week-text">
                        עם מינוי סופ״ש לעיתון המודפס                      
                    </span>
                   <div className="line2">
                   <span>של</span>                           
                   <span className="yedioth-label"></span>
                    <span>ב-₪69 לחודש.</span>
                    <a className="newspaper_terms" target="_self" href="https://z.ynet.co.il/mShort/generics/Leads/weekend/?utm_source=ynet&utm_medium=cpp&utm_campaign=yedioth#personal-details">
                        בהתאם לתנאים.
                    </a>
                    </div>
                </div>
            </div>
            <div className="footer">
                <div className="footer-links">
                    <ul>
                        <li><HyperLinkBuilder linkTarget={targetLink} href={contactUrl}>צור קשר</HyperLinkBuilder></li>
                        <li>|</li>
                        <li><HyperLinkBuilder linkTarget={targetLink} href={privacyUrl}> מדיניות פרטיות</HyperLinkBuilder></li>
                    </ul>
                </div>
                <div className="footer-terms-text">
                    לביטול מינוי ידיעות+ כדין יש לשלוח שם מלא וטלפון באחד מהאופנים הבאים:  <a target="_blank" href={contactUrl}>מילוי טופס</a> או בדוא״ל <a href="mailto:support.plus@yedioth.co.il">support.plus@yedioth.co.il</a>  או בת.ד 438 ראשון לציון או בטל׳  3733* / 03-6933933 או בפקס 03-6933999 | ידיעות מינויים ח.פ 540181054
                </div>
            </div>
        </div>
    );
};

export default PremiumPaywallCheckoutPlans;